import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgStorefront = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M25.375 10.5a.862.862 0 0 0-.033-.24l-1.57-5.491A1.758 1.758 0 0 0 22.095 3.5H5.906a1.758 1.758 0 0 0-1.679 1.269l-1.568 5.49a.863.863 0 0 0-.034.241v1.75a4.375 4.375 0 0 0 1.75 3.5v7.875a.875.875 0 0 0 .875.875h17.5a.875.875 0 0 0 .875-.875V15.75a4.374 4.374 0 0 0 1.75-3.5V10.5ZM5.906 5.25h16.188l1.249 4.375H4.66L5.906 5.25Zm5.469 6.125h5.25v.875a2.625 2.625 0 0 1-5.25 0v-.875Zm-1.75 0v.875a2.625 2.625 0 0 1-3.841 2.325.859.859 0 0 0-.2-.116 2.625 2.625 0 0 1-1.209-2.209v-.875h5.25Zm12.25 11.375H6.125v-6.212a4.374 4.374 0 0 0 4.375-1.663 4.374 4.374 0 0 0 7 0 4.374 4.374 0 0 0 4.375 1.663v6.212Zm.54-8.29a.884.884 0 0 0-.198.114 2.625 2.625 0 0 1-3.842-2.324v-.875h5.25v.875a2.625 2.625 0 0 1-1.21 2.21Z" />
  </svg>
);
export default SvgStorefront;
